var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptimalRates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1697 44.8492C57.175 44.8492 69.3393 41.1833 69.3393 36.6611V51.8633C69.3393 56.1404 57.175 59.7367 42.1697 59.7367C27.1643 59.7367 15.0001 56.1404 15.0001 51.8633V36.6611C15.0001 41.1833 27.1643 44.8492 42.1697 44.8492Z",
    fill: "url(#paint0_linear_79_1105)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1696 59.7357C55.1961 59.7357 69.3392 56.8141 69.3392 52.292V64.7022C64.5516 65.8282 60.7597 69.5361 59.5133 74.2761C54.8079 75.4175 48.763 76.1119 42.1696 76.1119C27.1642 76.1119 15 72.5156 15 68.2385V52.292C15 56.8141 29.1431 59.7357 42.1696 59.7357Z",
    fill: "url(#paint1_linear_79_1105)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5273 74.2243C54.8199 75.4037 48.7696 76.1129 42.1696 76.1129C27.1642 76.1129 15 72.447 15 67.9248V83.127C15 87.404 27.1642 91.0003 42.1696 91.0003C50.9988 91.0003 58.8445 89.7552 63.8071 87.8589C60.9137 85.4145 59.0762 81.7594 59.0762 77.6751C59.0762 76.4817 59.233 75.3249 59.5273 74.2243Z",
    fill: "url(#paint2_linear_79_1105)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3392 36.7282C69.3392 41.213 57.1748 44.8486 42.1696 44.8486C27.1642 44.8486 15 41.213 15 36.7282C15 32.2434 27.1642 28.4724 42.1696 28.4724C57.1748 28.4724 69.3392 32.2434 69.3392 36.7282Z",
    stroke: "#302F3A",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3392 52.2916C69.3392 56.4027 57.1748 59.7354 42.1696 59.7354C27.1642 59.7354 15 56.4027 15 52.2916",
    stroke: "#302F3A",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 67.9242C15 72.4464 27.1642 76.1123 42.1696 76.1123C48.5608 76.1123 54.4366 75.4472 59.0766 74.3342",
    stroke: "#302F3A",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3392 36.6608V63.8365M15 36.6608V83.1266C15 87.4037 27.1642 91 42.1696 91C50.3351 91 58.1962 89.585 63.1767 87.9249",
    stroke: "#302F3A",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6603 38.723C41.6603 38.9992 41.8841 39.223 42.1603 39.223C42.4364 39.223 42.6603 38.9992 42.6603 38.723L41.6603 38.723ZM42.6603 38.723L42.6603 22.0781L41.6603 22.0781L41.6603 38.723L42.6603 38.723Z",
    fill: "url(#paint3_linear_79_1105)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9712 10.0407C57.5178 20.0923 47.7023 23.2581 43.0135 22.9103C42.521 22.8737 42.1774 22.43 42.2258 21.9385C43.2182 11.859 53.275 8.68117 58.179 9.02471C58.6923 9.06067 59.0449 9.53147 58.9712 10.0407Z",
    fill: "url(#paint4_linear_79_1105)",
    fillOpacity: 0.5,
    stroke: "#AAECD8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3571 10.0407C26.8105 20.0923 36.626 23.2581 41.3149 22.9103C41.8073 22.8737 42.151 22.43 42.1026 21.9385C41.1101 11.859 31.0533 8.68117 26.1494 9.02471C25.6361 9.06067 25.2835 9.53147 25.3571 10.0407Z",
    fill: "url(#paint5_linear_79_1105)",
    fillOpacity: 0.5,
    stroke: "#AAECD8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.4017,
    cy: 77.6751,
    r: 13.8255,
    fill: "url(#paint6_linear_79_1105)",
    fillOpacity: 0.5,
    stroke: "#AAECD8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4033 70.5V84.8505",
    stroke: "#AAECD8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6635 73.1094H70.7713C70.1658 73.1094 69.5851 73.3499 69.157 73.7781C68.7288 74.2062 68.4883 74.7869 68.4883 75.3924C68.4883 75.9979 68.7288 76.5786 69.157 77.0068C69.5851 77.4349 70.1658 77.6755 70.7713 77.6755H74.0328C74.6383 77.6755 75.219 77.916 75.6472 78.3441C76.0753 78.7723 76.3158 79.353 76.3158 79.9585C76.3158 80.564 76.0753 81.1447 75.6472 81.5728C75.219 82.001 74.6383 82.2415 74.0328 82.2415H68.4883",
    stroke: "#AAECD8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_1105",
    x1: 15.0001,
    y1: 36.6611,
    x2: 43.9514,
    y2: 77.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_1105",
    x1: 15,
    y1: 52.292,
    x2: 45.1907,
    y2: 93.7131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_1105",
    x1: 15,
    y1: 67.9248,
    x2: 44.8536,
    y2: 105.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_79_1105",
    x1: 42.6603,
    y1: 22.9104,
    x2: 42.6603,
    y2: 38.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_79_1105",
    x1: 50.6207,
    y1: 9.69679,
    x2: 50.6207,
    y2: 22.9357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_79_1105",
    x1: 33.7076,
    y1: 9.69679,
    x2: 33.7076,
    y2: 22.9357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_79_1105",
    x1: 72.4017,
    y1: 65.6822,
    x2: 72.4017,
    y2: 91.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimalRates);
export default __webpack_public_path__ + "static/media/OptimalRates.ec4bc931c371cd0b1e8135be7b135184.svg";
export { ForwardRef as ReactComponent };